import * as basiclightbox from 'basiclightbox';
import * as Event from '../tools/Event';
import { iconSVG } from '../tools/utils';


export const init = () => {
	const VIDEO_ATTR = 'data-youtube';
	const VIDEO_SELECTOR = `[${VIDEO_ATTR}]`;
	const VIDEO_ID = '{{ videoID }}';
	const CLOSE_SELECTOR = '.basicLightbox__close';
	const TEMPLATE = `
		<div class="basicLightbox__iframe">
			<iframe width="560" height="315" src="https://www.youtube.com/embed/${VIDEO_ID}" frameborder="0" allowfullscreen></iframe>
		</div>
		<a href="#" class="basicLightbox__close">
			<span class="vhide">Zavřít</span>
			${iconSVG('close')}
		</a>
	`;
	let lightbox;

	const onOpen = (event) => {
		event.preventDefault();

		const target = event.target.closest(VIDEO_SELECTOR);
		const videoID = target.getAttribute(VIDEO_ATTR);
		const template = TEMPLATE.replace(VIDEO_ID, videoID);

		lightbox = basiclightbox.create(template);
		lightbox.show();
	};

	const onClose = (event) => {
		event.preventDefault();

		lightbox.close();
	};


	Event.on(document, 'click', onOpen, VIDEO_SELECTOR);
	Event.on(document, 'click', onClose, CLOSE_SELECTOR);
};



// WEBPACK FOOTER //
// ./src/js/components/youtube.js